export function LinkButtonsNavbar() {
  return (
    <>
      {/* <li>
        <a className="button" href="https://discord.com/invite/XrmrFfTbUa" target="_blank">
          <i className="icon fa-brands fa-discord fa-xl"></i>
        </a>
      </li>
      <li>
        <a className="button" href="https://www.youtube.com/@Kachanov" target="_blank">
          <i className="icon fa-brands fa-youtube fa-xl"></i>
        </a>
      </li> */}
      <li>
        <a className="button" href="https://t.me/kachanovcraft" target="_blank">
          <i className="icon fa-brands fa-telegram fa-xl"></i>
        </a>
      </li>
    </>
  );
}
